import styled from 'styled-components';

import Flex from '../../atoms/flex';
import Button from '../../atoms/nButton'
import Text from '../../atoms/text';

export const Section = styled.section`
  padding-top: 18px;
`
export const SectionHead = styled(Flex)`
  padding: 18px 0 42px;
`
export const ButtonCreate = styled(Button)`
  font-weight: 400;
  font-size: 14px;
  padding: 10px 0;
  justify-content: center;
  width: 100%;
`

export const ButtonConfirmation = styled(Button)`
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  padding: 10px 40px;
`

export const FlexConfirmation = styled(Flex)`
`

export const TextConfirmation = styled(Text)`
  margin-bottom: 40px;
`